import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import blue from '@mui/material/colors/blue';
import {Explanation} from "./Explanation";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import "./explanation.css";



const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
});

function SimpleDialog(props) {
    const classes = useStyles();
    const { open, onClose } = props;

    const handleClose = (value) => {
        onClose(value);
    };





    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">Read Instructions</DialogTitle>
            <Explanation/>
        </Dialog>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
   /* selectedValue: PropTypes.string.isRequired,*/
};

export default function Instructions(props) {
    const [open, setOpen] = React.useState(false);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button
                style={{marginLeft: "3%"}}
                variant="outlined"
                color="primary"
                onClick={handleClickOpen}
                startIcon={<HelpOutlineIcon/>}
            >
                { (props.title) ?
                    props.title
                  :
                    "Instructions"
                }
            </Button>
            <SimpleDialog  open={open} onClose={handleClose} />
        </React.Fragment>
    );
}
